import "./FormActionButton.css";

export default function FormActionButton({
  onBack,
  onNext,
  onSubmit,
  backTitle = "Back",
  nextTitle = "Next",
  submitTitle = "Submit",
  greyedOut = false,
  extraBold = false,
  backTestId = "btn-back",
  nextTestId = "btn-next",
  submitTestId = "btn-submit",
}) {
  return (
    <div className="col-12">
    <div className="row gx-2 steps action-button mt-4">
      {onBack && (
        <div
          className="col-md-6 text-center mx-auto"
        >
          <button
            type="button"
            className="btn-w color3 w-100 back-button"
            onClick={onBack}
            data-testid={backTestId}
          >
            {backTitle}
          </button>
        </div>
      )}
      {onNext && (
        <div
          className="col-md-6 text-center mx-auto"
        >
          <button
            type="button"
            className={`btn-w color3 w-100 ${extraBold ? "next-button-extrabold" : "next-button"} ${greyedOut ? "greyed-out" : ""}`}
            onClick={onNext}
            data-testid={nextTestId}
          >
            {nextTitle}
          </button>
        </div>
      )}
      {onSubmit && (
        <div className="col-md-6 text-center mx-auto">
          <button
            type="button"
            className={`btn-w color w-100 ${greyedOut ? "greyed-out" : ""}`}
            onClick={onSubmit}
            data-testid={submitTestId}
          >
            {submitTitle}
          </button>
        </div>
      )}
    </div>
    </div>
  );
}
